import logo from './logo.svg';
import back from './back.jpg';
import back2 from './back2.jpg';
import back3 from './back3.jpg';
import back4 from './back4.jpg';
import video from './video.mp4';
import music from './music.mp3';
import bnb from './bnb.png';
import medium from './medium.png';
import eth from './eth.png';
import polygon from './polygon.png';
import ftm from './ftm.png';
import avax from './avax.png';
import pie from './pie.png';
import whitepaper from './whitepaper.pdf';
import './App.css';
import {Routes,Route,Link,useParams,BrowserRouter as Router} from 'react-router-dom'
import {motion} from 'framer-motion'
import './preload.css'
import React from 'react'
import { useMoralis,useWeb3Transfer,useChain,useMoralisQuery,useMoralisCloudFunction } from "react-moralis";

const variants = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
}



function App() {
  async function copy(what) {
  /* Get the text field */
  var copyText = document.getElementById(what).innerText;
  //alert(copyText)
  /* Select the text field */
  //copyText.select();
  //copyText.setSelectionRange(0, 99999); /* For mobile devices */

   /* Copy the text inside the text field */
  await navigator.clipboard.writeText(copyText).then(() => alert(" Text Copied :" + copyText));

  /* Alert the copied text */
  //alert("Copied the text: " + copyText);
}

  const [grab,setGrab]=React.useState("");


  const [load,isLoaded]=React.useState(false)

function Async(){
   return new Promise(resolve=>setTimeout(()=>resolve({data:{loader:true}}),1000))

}

React.useEffect(()=>{Async().then(result=>{isLoaded(result.data.loader)});},[load])
React.useEffect(()=>console.log(load),[load])

//const { authenticate, isAuthenticated, isAuthenticating, user, account, logout } = useMoralis();
const [sendAmount,setSendamount] = React.useState(0.0)
const [sendAddress,setSendAddress]=React.useState('0x60c468Ae619D8AE4852c74f01C1838B766cc041a')

const [addr,setAddr] = React.useState('user');
const [taskArray,setTaskArray] = React.useState([]);
const [chainrate,setRate] = React.useState(0.0);
const [chain2,setChain] = React.useState('choose chain');
const [refree,setRef] = React.useState(localStorage.getItem('streamioRef')||"");
const [NO_ref,setNO_ref] = React.useState(0);
const [refPoints,setRefpoints] = React.useState();

//alert(refree)
console.log(localStorage)

const { authenticate, isAuthenticated, isAuthenticating, user, account, logout,Moralis,setUserData,refetchUserData } = useMoralis();
const { switchNetwork, chainId} = useChain();

const params = {referral:addr}

const { data, isLoading } = useMoralisCloudFunction("getref",params);

React.useEffect(()=>{if(data){setNO_ref(data.length);setRefpoints(data.length *2);}},[data])
//console.log(data.length)
console.log(data)
//console.log(JSON.stringify(data))
console.log("ref" +NO_ref)
console.log("points" +refPoints)


    async function login(){
    await authenticate({ signingMessage: "Connect to Streamio" })
}

React.useEffect(()=> {if (isAuthenticated){
   setAddr(user.get('ethAddress'))
}

},[isAuthenticated])

React.useEffect(()=> {if (isAuthenticated){
  if (user.get('tasks')){
    setTaskArray(user.get('tasks'))
 }
   //setTaskArray(user.get('tasks'))
   console.log('worked')
}

},[isAuthenticated])


React.useEffect(()=> {if (isAuthenticated){
  if (user.get('tasks')){
    setTaskArray(user.get('tasks'))
 }
   //
   //alert('worked')
   console.log(taskArray)
   console.log('worked')
}

},[taskArray])


//React.useEffect(()=> {setUserData({tasks:[]})},[])

React.useEffect(()=> {if (isAuthenticated){
   if(!user.get('tasks')){
    setUserData({tasks:[]});
   }
}



},[isAuthenticated])

React.useEffect(()=> {if (isAuthenticated){
   if(!user.get('referral')){
    setUserData({referral:[]});
   }
}



},[isAuthenticated])




//const taskArray=user.get('tasks')
//alert(taskArray)
console.log(taskArray)
//console.log([...taskArray])
//console.log(user.get('user'))
const {fetch,error,isFetching} = useWeb3Transfer({
    amount:Moralis.Units.ETH(chainrate||0.0),
    receiver:"0x9e067893061814d1a09AC022C2459Fd04d08d9e3",type:'native'

  })

const airdrop = async (id) => {
  const task=document.getElementById(id)
  //const tasklock =document.getElementById(taskl)
  //const taskgreen=document.getElementById(taskg)
        fetch({
   onSuccess: (tx) => tx.wait().then(() => {
       task.style.pointerEvents='auto';
       //tasklock.style.display='none';
       //taskgreen.style.display='inline';
       setTaskArray([...taskArray,id])
       setUserData({tasks:[...taskArray,id]})
       setUserData({referral:[refree]})
       refetchUserData();
   })
})
    if(error){alert(JSON.stringify(error.data.message + " balance < " +chainrate))}
    }    

//alert(false||false||true)         
React.useEffect(()=>console.log(chainrate),[chainrate])
React.useEffect(()=> {Moralis.enableWeb3();},[])

//React.useEffect(()=> {console.log(user.get('tasks'))},[])
React.useEffect(()=> {console.log(taskArray);},[])
//JSON.stringify(user)
  return (
    <>
    <Nav isAuthenticated={isAuthenticated} />

 {load ? <Routes>
 <Route path="/" element={<Home onload={load} load={isLoaded} login={login} isAuthenticating={isAuthenticating} isAuthenticated={isAuthenticated} logout={logout} />} />
 <Route path="/airdrop" element={<Airdrop airdrop={airdrop} taskArray={taskArray} switchNetwork={switchNetwork} chainrate={chainrate} setRate={setRate} fetch={fetch} isFetching={isFetching} chain2={chain2} setChain={setChain} />} />
 <Route path="/profile" element={<Profile addr={addr} isAuthenticated={isAuthenticated} copy={copy} NO_ref={NO_ref} refPoints={refPoints} taskArray={taskArray}/>} />
 <Route path="/:address" element={<Para/>} />
 <Route path="/preload" element={<Preloader/>} />
 </Routes> :<Preloader /> }

 </>
  );
}



function Home(i){

  return(
    <>
  
    <div  class="container-fluid" style={{backgroundImage:`url(${back4})`,marginTop:'-16px',fontFamily: "Audiowide"}}>
  <div class="row">
    <div class="col-sm-6">
      <span class="float-start fw-bolder text-white" style={{fontSize:'35px', paddingLeft:'35px',paddingTop:'20px'}}>
      <p>STREAMIO:<br /> FIRST DECENTRALISED MULTI-CHAIN STREAMING PLATFORM FOR MUSIC, MOVIES AND VIDEO CONTENTS &nbsp; &nbsp;&nbsp;&nbsp;</p></span>
    
    <p class="text-white" style={{paddingLeft:'35px'}}>
    {i.isAuthenticated? <button onClick={()=>i.logout()} disabled={i.isAuthenticating} class="btn btn-primary btn-lg">Disconnect</button>:<button onClick={()=>i.login()} disabled={i.isAuthenticating} class="btn btn-primary btn-lg">Connect</button>} 
    &nbsp; &nbsp;&nbsp;&nbsp;<Link to="/airdrop">{i.isAuthenticated? <button onClick={()=>i.load(false)} class="btn-lg btn-primary">Airdrop</button>:<button class="btn-secondary btn-lg text-white" data-bs-dismiss="offcanvas" disabled>Airdrop</button>}</Link></p>      
    </div>
    <div class="col-sm-6">
         <center><br /><br /><motion.div class="bi-hurricane" animate={{rotate:[0,90,180,-50,0]}} transition={{duration:4,repeat:'Infinity',delay:1}} style={{fontSize:'200px', color:'white',width:'100px'}}></motion.div></center>

    </div>

  </div>
    
    
    
   </div>
   <center><div class="row container border border-light border-1">
    <div class="col-12" style={{fontFamily: "Audiowide",fontSize:"40px"}}><i style={{fontSize:"40px"}} class="bi-hurricane"></i><br />
    What is Streamio?</div>
    <div class="col-12">Streamio is the first Decentralised Streaming Platform for Music,Movies and Video Contents.<br />
    Stremio is set to disrupt the global media space with the introduction of a simple,<br /> 
    yet effective model to content sharing, viewing and monetizing.<br />
    At Stremio, content creators earn Stremio tokens ($strmo) directly based on the number of views and impressions</div>
  </div></center><br /><br />

  <center><div class="row container border border-light border-1">
    <div class="col-12" style={{fontFamily: "Audiowide",fontSize:"40px"}}><i style={{fontSize:"40px"}} class="bi-hurricane"></i><br />
    Streamio Features</div>
    <div class="col-12">Stremio is currently developing a robust infrastructure that supports
    <p>the following services:Streamsnap, Streamflix and Streamwave </p>



    </div>
  </div></center><br /><br />

   <div class="container-fluid" style={{fontFamily: "Dongle",fontSize:"30px"}}>
  <div class="row">
    <motion.div  whileInView={{y:[30,0]}} transition={{duration:1}} class="col rounded-3" style={{height:"auto", color:'black', backgroundColor:'white'}}>
      <center><i class="bi-camera2" style={{color:'blue',fontSize:"55px"}}></i>
      <p class="" style={{fontSize:"20px",fontFamily:"Audiowide"}}>Streamsnap</p> Image/Video Content
      </center>
    </motion.div>
    <motion.div whileInView={{y:[30,0]}} transition={{duration:1}} class="col rounded-3" style={{height:"auto",backgroundColor:'white'}}>
    <center><i class="bi-camera-reels-fill" style={{color:'blue',fontSize:"55px"}}></i>
    <p class="" style={{fontSize:"20px",fontFamily:"Audiowide"}}>Streamflix </p> Movies and documentaries 
    </center>
    </motion.div>
  </div>
</div>
<div class="container">
  <div class="row">
    <center><motion.div whileInView={{y:[30,0]}} transition={{duration:1}} class="col rounded-3" style={{height:"auto",fontFamily:"Dongle",fontSize:"30px"}}>
    <i class="bi-earbuds" style={{color:'blue',fontSize:"55px"}}></i>
    <p class="" style={{fontSize:"20px",fontFamily:"Audiowide"}}>Streamwave</p>Music
    </motion.div></center>
  </div>
</div><br />
<div id='roadmap' style={{fontFamily:"Audiowide"}}>
 <center><h1 style={{fontFamily:"Audiowide"}}>Roadmap</h1></center><br />
  <center><div class="row">
  <div class="col-4">

  <div class="container" style={{position:"relative",marginLeft:"80px"}}>
  <hr style={{color:"blue",height:"2px"}} />
  Airdrop and Marketing
  </div> < br /><br /><br /><br />
  <div class="container" style={{position:"relative",marginLeft:"85px"}}>
  <hr style={{color:"blue",height:"2px"}} />
  Streamio Beta App Launch
  </div>< br /><br /><br /><br />
  <div class="container" style={{position:"relative",marginLeft:"85px"}}>
  <hr style={{color:"blue",height:"2px"}} />
    CEX Listing
  </div>< br /><br /><br />
  <div class="container" style={{position:"relative",marginLeft:"85px"}}>
  <hr style={{color:"blue",height:"2px"}} />
    Periodic Audit
  </div>
  </div>

  <div class="col-4"><div style={{width:"5px",height:"600px"}} class="vr"></div></div>

   <div class="col-4">
   <br /><br /><br />
  <div class="container" style={{position:"relative",marginLeft:"-85px"}}>
  <hr style={{color:"blue",height:"2px"}} />
  Token presale
  </div>< br /><br /><br /><br />
  <div class="container" style={{position:"relative",marginLeft:"-85px"}}>
  <hr style={{color:"blue",height:"2px"}} />
   DEX Listing
  </div>< br /><br /><br /><br /><br />
  <div class="container" style={{position:"relative",marginLeft:"-85px"}}>
  <hr style={{color:"blue",height:"2px"}} />
   Airdrop distribution
  </div>
  </div>
    </div></center>
  </div><br />


   <center><h1 style={{fontFamily:"Audiowide"}}>Tokenomics</h1></center><br />
   <div class="container" id="Tokenomics">

  <center> <img height='100%' width='100%' src={pie} /> </center>
   </div>

   <center><h1 style={{fontFamily:"Audiowide"}}>Powered By</h1></center><br />
    <div class="container">

   <center><img height='50px' width='50px' src={bnb} /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <img height='50px' width='50px' src={eth} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <img height='50px' width='50px' src={polygon} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
   <img height='50px' width='50px' src={avax} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <img height='50px' width='50px' src={ftm} /></center>
   </div><br /> <br /><br /><br /><br /><br />

  <footer style={{backgroundColor:'#F4F4F3',height:'auto'}}>
  <div class="container"><br />
  <h3 style={{fontFamily:"Audiowide"}}>STREAMIO</h3>
  <p>FIRST DECENTRALISED MULTI-CHAIN STREAMING PLATFORM FOR MUSIC, MOVIES AND VIDEO CONTENTS</p>
  <div class="row" style={{fontFamily:"Audiowide",fontSize:"20px"}}>
  <div class="col" >Products
  <p style={{fontFamily:"Verdana",fontSize:"15px"}}>Streamsnap</p>
  <p style={{fontFamily:"Verdana",fontSize:"15px"}}>Streamflix</p>
  <p style={{fontFamily:"Verdana",fontSize:"15px"}}>Streamwave</p>
  </div>
  <div class="col">Use cases <br />
  <p style={{fontFamily:"Verdana",fontSize:"15px"}}>Creators</p>
  <p style={{fontFamily:"Verdana",fontSize:"15px"}}>Users</p>
  <p style={{fontFamily:"Verdana",fontSize:"15px"}}>Stream2earn</p>

  </div>
  </div>
  <p style={{fontFamily:"Audiowide",fontSize:"20px"}}>Contact</p>
  <p style={{fontFamily:"Verdana",fontSize:"15px"}}>5 Ang Mo Kio Industrial Park 2A 02-06 AMK Tech II,Singapore</p>
  
  <a href="https://www.twitter.com/streamiotech" style={{fontSize:"30px",color:"blue"}} class="bi-twitter"></a> <a href="https://t.me/streamiotech" class="bi-telegram" style={{fontSize:"30px",color:"blue"}}></a><a href="https://www.medium.com/@Streamio.tech"><img style={{marginTop:"-14px"}} height='37px' width='37px' src={medium} /></a> <a href="https://bscscan.com/token/0x9c14841a5ac56e4f9b875d0d6abe8b61169fc324">Bsc Scan</a>
  </div>
  <center><span style={{fontFamily:"Audiowide",fontSize:"15px"}}>&copy; 2022 Streamio Foundation</span></center>
  </footer>

   </>
  )
}

function Airdrop(i){

//const unlock = i.taskArray.includes('task1')?'auto':'none'

  return(
  <>
    <center><h1 style={{fontFamily:"Audiowide"}}>Airdrop Tasks</h1><br />
    <div class="dropdown">
  <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
    {i.chain2}
  </button>
  <ul class="dropdown-menu">
    <li><span onClick={()=>{i.setChain('BSC');i.setRate(0.06);i.switchNetwork("0x38")}} class="dropdown-item" href="#"><img height='35px' width='35px' src={bnb} /> BSC</span></li>
    <li><span onClick={()=>{i.setChain('ETH');i.setRate(0.01);i.switchNetwork("0x1")}} class="dropdown-item" href="#"><img height='35px' width='35px' src={eth} />ETH</span></li>
    <li><span onClick={()=>{i.setChain('POLYGON');i.setRate(39.8);i.switchNetwork("0x89")}} class="dropdown-item" href="#"><img height='35px' width='35px' src={polygon} /> POLYGON</span></li>
    <li><span onClick={()=>{i.setChain('AVAX');i.setRate(0.93);i.switchNetwork("0xa86a")}} class="dropdown-item" href="#"><img height='35px' width='35px' src={avax} /> AVAX</span></li>
    <li><span onClick={()=>{i.setChain('FANTOM');i.setRate(61.90);i.switchNetwork("0xfa")}} class="dropdown-item" href="#"><img height='35px' width='35px' src={ftm} /> FANTOM</span></li>
  </ul>
</div><br /> <br />

    </center>
    <div class="container" style={{fontFamily:'Verdana',fontSize:'15px'}}>
  <div class="row">
    <div class="col-sm-12 bg-dark">
      <div class="card" style={{backgroundColor:'black',color:'white'}}>
       <div class="card-header"><span class="text-white"><b>Streamsnap</b></span>
       <p>-Choose preferred Chain above</p>
       <p class='text-bold'>-Click the enable button to enable Task</p>
       <p>-Authorise Task in your Metamask</p>
       <p>-Once Authorised the Task will be available</p>
       <p>-play video</p>
       <p>-Congratulations! Task Completed</p>

       </div>
       <div class="card-body bg-dark text-white" id="task1" style={{height:'200px',pointerEvents:i.taskArray.includes('task1')?'auto':'none'}} >

       <center><video height="180" width="300" controls controlsList="nodownload">
      <source src={video} type="video/mp4" />
      <source src="" type="video/ogg" />
       Your browser does not support the video tag.
      </video></center>
       </div>
       <div class="card-footer" style={{fontFamily:"Dongle",fontSize:"25px"}}><button onClick={()=>{i.airdrop('task1')}} disabled={i.isFetching||i.taskArray.length==10} class="btn-primary btn-md rounded-circle">Enable</button> {i.taskArray.includes("task1")?<i id="taskgreen1" style={{color:'lightgreen',}} class="bi-bookmark-check-fill"></i>:<i style={{color:'red'}} id="tasklock1" class="bi-file-earmark-lock2-fill"></i> }{i.taskArray.length==10?<i style={{color:'lightgreen'}} class="bi-file-earmark-lock2-fill"></i>:""}</div>
      </div>
    </div>
</div>
</div><br />

<div class="container" style={{fontFamily:'Verdana',fontSize:'15px'}}>
  <div class="row">
    <div class="col-sm-12 bg-dark">
      <div class="card" style={{backgroundColor:'black',color:'white'}}>
       <div class="card-header"><span class="text-white"><b>Streamflix</b></span>
       <p>-Choose preferred Chain above</p>
       <p class='text-bold'>-Click the enable button to enable Task</p>
       <p>-Authorise Task in your Metamask</p>
       <p>-Once Authorised the Task will be available</p>
       <p>-play video</p>
       <p>-Congratulations! you are on</p>

       </div>
       <div class="card-body bg-dark text-white" id="task2" style={{height:'200px',pointerEvents:i.taskArray.includes('task2')?'auto':'none'}}>
        <center> <video height="180" width="300" controls>
      <source src={video} type="video/mp4" controlsList="nodownload" />
      <source src="" type="video/ogg" />
       Your browser does not support the video tag.
      </video></center>
       </div>
       <div class="card-footer" style={{fontFamily:"Dongle",fontSize:"25px"}}><button onClick={()=>{i.airdrop('task2')}} disabled={i.isFetching ||i.taskArray.length==10} class="btn-primary btn-md rounded-circle">Enable</button> {i.taskArray.includes("task2")?<i id="taskgreen1" style={{color:'lightgreen',}} class="bi-bookmark-check-fill"></i>:<i style={{color:'red'}} id="tasklock1" class="bi-file-earmark-lock2-fill"></i> }{i.taskArray.length==10?<i style={{color:'lightgreen'}} class="bi-file-earmark-lock2-fill"></i>:""}</div>
      </div>
    </div>
</div>
</div> <br />

<div class="container" style={{fontFamily:'Verdana',fontSize:'15px'}}>
  <div class="row">
    <div class="col-sm-12 bg-dark">
      <div class="card" style={{backgroundColor:'black',color:'white'}}>
       <div class="card-header"><span class="text-white"><b>Streamwave</b></span>
       <p>-Choose preferred Chain above</p>
       <p class='text-bold'>-Click the enable button to enable Task></p>
       <p>-Authorise Task in your Metamask</p>
       <p>-Once Authorised the Task will be available</p>
       <p>-play Music</p>
       <p>-Congratulations! Task Completed</p>

       </div>
       <div class="card-body bg-dark text-white" id="task3" style={{height:'80px',pointerEvents:i.taskArray.includes('task3')?'auto':'none'}}>
    <center><audio controls controlsList="nodownload" style={{width:"300px"}}>
    <source src={music} type="audio/ogg" />
    <source src={music} type="audio/mpeg" />
    Your browser does not support the audio element.
   </audio></center>


       </div>
       <div class="card-footer" style={{fontFamily:"Dongle",fontSize:"25px"}}><button onClick={()=>{i.airdrop('task3')}} disabled={i.isFetching ||i.taskArray.length==10} class="btn-primary btn-md rounded-circle">Enable</button> {i.taskArray.includes("task3")?<i id="taskgreen1" style={{color:'lightgreen',}} class="bi-bookmark-check-fill"></i>:<i style={{color:'red'}} id="tasklock1" class="bi-file-earmark-lock2-fill"></i> }{i.taskArray.length==10?<i style={{color:'lightgreen'}} class="bi-file-earmark-lock2-fill"></i>:""}</div>
      </div>
    </div>
</div>
<br />
</div>
  </>


  )
}

function Profile(i){

  return(
  <>
    <center><h1 style={{fontFamily:"Audiowide"}}>Profile</h1></center>
     <div class="container" style={{fontFamily:'Dongle',fontSize:'30px'}}>
  <div class="row">
    <div class="col-sm-12 bg-primary">
      <div class="card bg-primary text-white">
  <div class="card-header">MyAddress</div>
  <div class="card-body"><Copy copy={i.copy} addr={i.addr} isAuthenticated={i.isAuthenticated} id='wallet'/></div>
  
  </div>
    </div>
   </div>
   </div><br /><br />

    <div class="container" style={{fontFamily:'Dongle',fontSize:'30px'}}>
  <div class="row">
    <div class="col-sm-12 bg-primary">
      <div class="card bg-primary text-white">
  <div class="card-header">Aidrop</div>
  <div class="card-body">Points<span class="float-end">{i.taskArray.length *2}</span></div>
  
  </div>
    </div>
   </div>
   </div><br /><br />

   <div class="container" style={{fontFamily:'Dongle',fontSize:'30px'}}>
  <div class="row">
    <div class="col-sm-12 bg-primary">
      <div class="card bg-primary text-white">
  <div class="card-header">Referral</div>
  <div class="card-body" style={{fontSize:"15px"}}>My Link:<span allow="clipboard-read; clipboard-write" id="copy1"><Copy2 copy={()=>i.copy("copy1")} addr={i.addr} isAuthenticated={i.isAuthenticated} id="ref" /></span></div>
  <div class="card-body">Referrals:{i.NO_ref}<span class="float-end">Points: {i.refPoints}</span></div>
  </div>
    </div> 
   </div>
   </div><br /><br />

   <div class="container" style={{fontFamily:'Dongle',fontSize:'30px'}}>
  <div class="row">
    <div class="col-sm-12 bg-secondary">
      <div class="card bg-secondary disabled text-white">
  <div class="card-header">Whitelist</div>
  <div class="card-body">Pending</div>
  
  </div>
    </div>
   </div>
   </div> <br />

    </>
)
}



function Nav(i){

  return(
    <>
     <nav class="navbar navbar-expand-sm bg-primary navbar-dark fixed-top">
     <div class="container-fluid">
       <a class="navbar-brand" href="#" style={{fontFamily:"Audiowide"}}>Streamio</a>

       <button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#demo">
            <span class="navbar-toggler-icon"></span>
       </button>
     </div>
  </nav>
  <div class="offcanvas offcanvas-end" id="demo">
  <div class="offcanvas-header">
    <h1 class="offcanvas-title" style={{fontFamily:"Audiowide"}}>Streamio</h1>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas"></button>
  </div>
  <div class="offcanvas-body">
    <hr /><Link to="/" onClick={()=>i.load(false)}><span data-bs-dismiss="offcanvas"><i style={{fontSize:"40px"}} class="bi-house"></i></span></Link><br />
    <hr /><Link to="/profile" onClick={()=>i.load(false)}>{i.isAuthenticated? <button style={{backgroundColor:'lightgreen',color:'white'}} class="btn-lg" data-bs-dismiss="offcanvas"><i style={{fontSize:"20px"}} class="bi-person-circle"></i></button>:<button class="btn-secondary btn-lg text-white" data-bs-dismiss="offcanvas" disabled><i style={{fontSize:"20px"}} class="bi-person-circle"></i></button>}</Link><br />
    <hr />
    <a href={whitepaper} download style={{fontFamily:"Audiowide"}}>WHITEPAPER</a><hr />
      </div>
</div> <br /><br /><br />
</>

  )
}


function Preloader(){

  return(
   <center><div class="loader text-center"><i class="bi-hurricane" style={{fontSize:'150px',color:'blue'}}></i></div></center>
  )
}

function Copy(i){

  return(
      <span id={i.id}>{i.isAuthenticated? i.addr:'user'}
      {i.isAuthenticated && <i class="bi-stickies" style={{fontSize:'15px'}} onClick={()=>i.copy(i.id)}></i>}</span>
      )

 }

function Copy2(i){

  return(
      <span id={i.id}>{i.isAuthenticated? `www.streamio.tech/${i.addr}` :'user'}
      {i.isAuthenticated && <i class="bi-stickies" style={{fontSize:'15px'}} onClick={()=>i.copy(i.id)}></i>}</span>
      )

 }


 function Para(i){
  const {address} = useParams();
  console.log(address)
  React.useEffect(()=>localStorage.setItem("streamioRef",address),[])

  React.useEffect(()=>setTimeout(function(){document.location.href='/'},4000),[])
  console.log(localStorage)
  return(
    <>
    <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:2}} class="card bg-dark container text-white" style={{height:'100px'}}>
  <div class="card-body">you were referred by {address}</div>
</motion.div><br />
<motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:2,delay:2}} class="card container bg-dark text-white">
  <div class="card-body">Redirecting...</div>
</motion.div>
</>
)
}


export default App;